{
  "uploadFile": "Upload file",
  "working": "Working",
  "thinking": "Thinking",
  "newChat": "New Chat",
  "recentChats": "Recent Chats",
  "recents": "Recents",
  "chats": "Chats",
  "chat": "Chat",
  "files": "Files",
  "agents": "Agents",
  "messages_one": "{{count}} message",
  "messages_other": "{{count}} messages",
  "clickToRename": "Click to rename",
  "deleteChat": "Delete chat",
  "archive": "Archive",
  "unarchive": "Unarchive",
  "archived": "Archived",
  "welcomeTitle": "Welcome to Agion Assistants",
  "welcomeSubtitle": "Start a conversation with the Agion Assistant or select a specific agent",
  "missionWelcomeTitle": "Mission Chat",
  "missionWelcomeSubtitle": "Start a conversation with the mission team. All participants can see and respond to messages.",
  "agentWelcomeTitle": "Agent Chat",
  "agentWelcomeSubtitle": "Start a conversation with this agent. The agent will assist you based on its capabilities and trust level.",
  "agionAssistants": "Agion Assistants",
  "noAgentAccess": "No Agent Access",
  "noAgentAccessDesc": "You currently don't have access to any agents. Please contact your administrator.",
  "connecting": "Connecting to real-time updates...",
  "reconnecting": "Reconnecting... (attempt {{attempt}})",
  "disconnected": "Real-time updates disconnected",
  "connectionError": "Connection error - retrying...",
  "cancelled": "Request cancelled by user",
  "processingError": "Sorry, I encountered an error processing your request. Please try again.",
  "typeToMention": "Type @ to mention files or agents...",
  "referencedFiles": "Referenced files ({{count}}):",
  "attachedFiles": "Attached files ({{count}}):",
  "all": "All",
  "filesCount": "Files ({{count}})",
  "agentsCount": "Agents ({{count}})",
  "noFilesOrAgents": "No files or agents available",
  "uploadFilesPrompt": "Upload files or wait for agents to load...",
  "noFilesFound": "No files found",
  "noAgentsFound": "No agents found",
  "sendHint": "Press Enter to send, Shift+Enter for new line",
  "mentionHint": "Type @ to reference files or agents",
  "attachHint": "Click paperclip to attach files",
  "attachFile": "Attach file",
  "uploadingToStorage": "Uploading to storage...",
  "processing": "Processing...",
  "navigateHint": "↑ ↓ to navigate",
  "selectHint": "↵ to select",
  "dismissHint": "esc to dismiss",
  "you": "You",
  "assistant": "Assistant",
  "generatedChart": "Generated Chart",
  "signOut": "Sign Out",
  "aiAgent": "AI Agent",
  "noDescription": "No description available",
  "howCanIHelp": "How can I help you today?",
  "addContent": "Add content",
  "mentionFile": "Mention a file",
  "settings": "Settings",
  "history": "History",
  "autoSelect": "Auto",
  "noResults": "No results found",
  "rename": "Rename",
  "delete": "Delete",
  "copy": "Copy to clipboard",
  "copied": "Copied!",
  "regenerate": "Regenerate",
  "processedIn": "Processed in {{time}}s",
  "maxFilesReached": "Maximum {{max}} files allowed",
  "tasks": "tasks",
  "tasksCount": "{{count}} tasks",
  "searchChats": "Search chats...",
  "noChatsFound": "No chats found",
  "participants": "participants",
  "external": "external",
  "showingAs": "Showing as",
  "internalNote": "Internal Note",
  "internal": "Note",
  "reply": "Reply",
  "replyToCustomer": "Reply to customer",
  "missionAccessDenied": "You do not have access to this mission. You may have been removed as a participant.",
  "missionAccessDeniedMessage": "Access denied. You are not a participant in this mission.",
  "voiceInput": "Voice input",
  "stopRecording": "Stop recording",
  "recording": "Recording...",
  "transcribing": "Transcribing...",
  "microphoneAccessDenied": "Microphone access denied",
  "recordingFailed": "Recording failed",
  "disclaimer": "Agents can make mistakes. Always verify results.",
  "failedToGetResponse": "Failed to get response",
  "downloadChart": "Download Chart",
  "freePlan": "Free plan",
  "unknownMission": "Unknown Mission",
  "unnamedMission": "Unnamed Mission",
  "missions": "Missions",
  "noMissions": "No missions available",
  "createMissionInAdmin": "Create a mission in the admin panel",
  "newMission": "New Mission",
  "awaitingHumanInput": "Awaiting human input",
  "open": "Open",
  "attention": "Attention",
  "running": "Running",
  "recent": "Recent",
  "showHosts": "Show hosts",
  "hideHosts": "Hide hosts",
  "timeAgo": {
    "justNow": "just now",
    "minutesAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "daysAgo": "{{count}}d ago"
  },
  "recentRuns": {
    "showAll": "Show all chats",
    "showMore": "Show more chats",
    "showFewer": "Show fewer",
    "loading": "Loading chats…",
    "loadError": "Earlier chats could not be loaded"
  },
  "missionRunning": "Mission running",
  "searchMissions": "Search missions...",
  "noMatchingMissions": "No matching missions",
  "drafts": "Drafts",
  "hostOnline": "Host online",
  "hostOffline": "Host offline",
  "hostStatusChecking": "Checking host status...",
  "hostStatusUnknown": "Host status unknown",
  "hosts": "Hosts",
  "noHosts": "No hosts available",
  "unassigned": "Unassigned",
  "hostGroup": "Host group",
  "selectMission": "Select a Mission",
  "selectMissionDescription": "Choose a mission from the sidebar to start chatting with your agent.",
  "clickNewChatToStart": "Click \"New Chat\" to start",
  "landing": {
    "title": "What would you like to work on?",
    "subtitle": "Choose how you'd like to get started",
    "missionChat": "Mission Chat",
    "missionChatDescription": "Run a mission and interact with it through chat",
    "knowledgeBase": "Knowledge Base",
    "knowledgeBaseDescription": "Ask questions about your organization's knowledge",
    "chatWithData": "Chat with Data",
    "chatWithDataDescription": "Query your connected data sources conversationally",
    "selectAMission": "Select a mission to start",
    "noActiveMissions": "No active missions available",
    "startChat": "Start Chat",
    "autostart": "Mission will start automatically",
    "searchMissions": "Search missions...",
    "recentlyUpdatedMissions": "Recently updated missions",
    "missionListSubtitle": "Your missions",
    "orStartNew": "or start a new conversation",
    "greeting": "What would you like to do?",
    "inputPlaceholder": "Describe what you need or drop a file...",
    "hint": "Type a message or drop a file, then select a mission",
    "removeFile": "Remove file",
    "loadError": "Your missions could not be loaded",
    "noMissionsGuest": "No missions have been shared with you yet. Ask the person who invited you to add you to one.",
    "noMissionsGuestWithInviter": "No missions have been shared with you yet. When someone shares one, it appears here — ask {{inviter}} to add you to one.",
    "noMissionsReader": "Missions you are added to appear here.",
    "guestOrgContext": "You're in {{org}}.",
    "guestOrgContextWithInviter": "You're in {{org}}, invited by {{inviter}}.",
    "guestCapabilities": "As a guest, you can open and run the missions that are shared with you. You can't create missions or invite other people.",
    "guestHintBody": "As a guest, you can open and run the missions shared with you by {{inviter}}. New ones appear here automatically.",
    "guestHintBodyNoInviter": "As a guest, you can open and run the missions shared with you. New ones appear here automatically.",
    "guestHintDismiss": "Dismiss",
    "draft": "Draft"
  },
  "welcome": {
    "greeting": "How can I help you today?",
    "subtitle": "Start a conversation or choose a suggestion below",
    "noMissionsSubtitle": "No active missions yet. Start a conversation or create a mission.",
    "startConversation": "Start a new conversation",
    "missionSubtitle": "Send a message to begin this mission",
    "agentsInMission": "Agents:",
    "startMission": "Start the mission",
    "suggestions": {
      "summarize": "Summarize recent mission results",
      "agents": "What agents are available?",
      "mission": "Help me create a new mission",
      "governance": "Explain a governance decision"
    },
    "agentSuggestions": {
      "intro": "Tell me about yourself",
      "help": "What can you help me with?"
    }
  },
  "modes": {
    "mission": "Mission",
    "kb": "Knowledge Base",
    "data": "Data"
  },
  "conversationHistory": {
    "title": "Conversations",
    "noConversations": "No conversations yet",
    "startNew": "Start a new conversation above"
  },
  "trigger": {
    "childMissionLaunched": "A new mission was triggered",
    "continueWith": "Continue with {{name}}?",
    "openMission": "Open Mission",
    "missionTriggered": "Mission triggered"
  },
  "customer": {
    "historyLoadFailed": "The conversation could not be loaded from the Edge host.",
    "historyLoadFailedHint": "The run may have said more than is shown here. Try again in a moment.",
    "historyHostUnknown": "The Edge host that ran this mission is not recorded, so its conversation cannot be found.",
    "progress": {
      "title": "Progress",
      "stepsCompleted": "{{completed}} of {{total}} steps",
      "allComplete": "All steps completed",
      "failed": "Execution failed"
    },
    "missionCompleted": "Mission completed successfully",
    "missionStopped": "Run stopped",
    "missionFailed": "Something went wrong. Please try again or contact support.",
    "missionAnswerTimeout": "The run ended because no answer came in time. Send a message to start a new run.",
    "missionToolReportedError": "The tool could not use this input: {{reason}}. Check the input and try again.",
    "missionCriteriaNotMet": "The run finished, but it did not meet all of its success criteria. Check the answer before you rely on it.",
    "missionNoResourceEvidence": "The run could not get any data from its connected systems, so the answer may be incomplete. Ask your administrator to check the connection before you rely on it.",
    "questionExpired": "This question has expired",
    "reconnecting": "Reconnecting...",
    "streamingUnavailable": "Real-time updates are temporarily unavailable. You can still browse your conversation history.",
    "typeMessage": "Type a message...",
    "typeToRestart": "Type a message to start a new run...",
    "newRunDivider": "New run started. Earlier messages are shown for reference.",
    "respondToQuestion": "Type your answer...",
    "waitingForMission": "Waiting for mission response...",
    "stop": "Stop",
    "stopMission": "Stop mission",
    "pause": "Pause",
    "pauseMission": "Pause mission",
    "resume": "Resume",
    "resumeMission": "Resume mission",
    "historyHostOfflineNamed": "{{name}}, the Edge host that holds this conversation, is offline. Try again when it is back.",
    "historyHostOffline": "The Edge host that holds this conversation is offline. Try again when it is back.",
    "runHostMoved": "This run started on another Edge host because the one that holds the earlier conversation is not available. Files from earlier messages are not available to this run.",
    "conversationOwnedByOther": "This conversation belongs to another person. Only they can read it here.",
    "conversationStartedAutomatically": "This conversation was started by a schedule or a trigger, not by a person. Its content opens only from the audit page."
  },
  "kb": {
    "title": "Knowledge Base",
    "placeholder": "Ask a question...",
    "thinking": "Searching knowledge base...",
    "noSources": "No sources found",
    "sources": "Sources",
    "fromOrg": "Organization",
    "fromMission": "Mission",
    "askFollowUp": "Ask a follow-up question..."
  },
  "data": {
    "title": "Chat with Data",
    "selectResources": "Select data sources",
    "selectSources": "Select data sources to query",
    "noResources": "No data sources available",
    "noSources": "No data sources available",
    "sourcesSelected": "sources selected",
    "askPrompt": "Ask a question about your data sources",
    "selected": "selected",
    "startChat": "Start Chat",
    "placeholder": "Ask about your data...",
    "querying": "Querying data sources..."
  },
  "governance": {
    "prefix": "Governance",
    "allowed": "Governance: Allowed",
    "denied": "Denied",
    "obfuscated": "Obfuscated",
    "escalated": "Escalated"
  },
  "trust": {
    "tooltip": {
      "tier0": "Restricted — This agent operates under maximum supervision. All actions require approval.",
      "tier1": "Limited — This agent can perform basic tasks but stops at important decisions.",
      "tier2": "Standard — This agent handles routine work and stops at key decisions.",
      "tier3": "Elevated — This agent has extended permissions and acts with minimal pauses."
    }
  },
  "executionLog": {
    "title": "Activity",
    "openPanel": "Open activity",
    "closePanel": "Close activity",
    "waitingForEvents": "Waiting for events...",
    "noEventsYet": "No events yet",
    "contentOnHost": "Content stored on the Edge host",
    "mission": "Mission",
    "rankingDegraded": "Ranking degraded",
    "noConfidentMatch": "No confident match",
    "warningCount": "{{count}} warning",
    "warningCount_other": "{{count}} warnings",
    "forced": {
      "label": "Finished early",
      "budget": "Finished early: ran out of turns. The result may be incomplete. Narrow what the step asks for, or split it.",
      "stuckRepeating": "Finished early: kept repeating the same call. The result may be incomplete. Change the step's instructions.",
      "repeatedFailure": "Finished early after repeated tool errors. The result may be incomplete. Check the connection the step uses.",
      "schemaChurn": "Finished early: the source data kept changing shape. The result may be incomplete. Check the source schema."
    }
  },
  "missionChat": {
    "editInDesigner": "Edit in Designer"
  },
  "workflow": {
    "status": "Workflow: {{status}}",
    "pause": "Pause",
    "resume": "Resume",
    "cancel": "Cancel",
    "approve": "Approve",
    "reject": "Reject",
    "progress": "{{completed}} of {{total}} steps completed",
    "currentStep": "Running: {{step}}{{agent}}",
    "turn": "Turn {{current}}/{{max}}",
    "turnProgress": "Turn {{current}} of {{max}}",
    "duration": "Duration: {{duration}}",
    "waitingApproval": "{{count}} step(s) waiting for approval",
    "noSteps": "No workflow steps defined",
    "dependsOn": "Depends on",
    "viewDetails": "View workflow details",
    "event": {
      "started": "Workflow Started",
      "startedDescription": "Running {{steps}} steps",
      "paused": "Workflow Paused",
      "pausedDescription": "Workflow has been paused",
      "resumed": "Workflow Resumed",
      "resumedDescription": "Workflow execution resumed",
      "completed": "Workflow Completed",
      "completedDescription": "Completed {{steps}} steps in {{duration}}",
      "failed": "Workflow Failed",
      "cancelled": "Workflow Cancelled",
      "cancelledDescription": "Workflow execution was cancelled",
      "stepStarted": "Step Started: {{step}}",
      "stepStartedAgent": "Agent {{agent}} is executing",
      "stepStartedDescription": "Step execution started",
      "stepProgress": "Step Progress: {{step}}",
      "stepProgressDescription": "Turn {{current}} of {{max}}",
      "stepCompleted": "Step Completed: {{step}}",
      "stepCompletedDescription": "Completed in {{duration}}",
      "stepFailed": "Step Failed: {{step}}",
      "stepWaitingApproval": "Approval Required: {{step}}",
      "unknown": "Workflow Event"
    },
    "command": {
      "statusHelp": "Show workflow status",
      "pauseHelp": "Pause running workflow",
      "resumeHelp": "Resume paused workflow",
      "cancelHelp": "Cancel running workflow",
      "approveHelp": "Approve pending step",
      "rejectHelp": "Reject pending step"
    }
  },
  "outputFile": {
    "download": "Download",
    "downloading": "Downloading…",
    "downloadFailed": "Download failed. Try again.",
    "noHost": "Files from this assistant can't be downloaded here yet.",
    "noLongerAvailable": "This file is no longer available. Ask the assistant to create it again.",
    "noAccess": "You don't have access to this file.",
    "hostOffline": "The host that holds this file is offline. Try again when it is connected."
  },
  "delivery": {
    "waiting": "Waiting for the files to finish uploading…",
    "sending": "Sending…",
    "queued": "Queued: the assistant reads it after its current step.",
    "delivered": "Delivered",
    "notConnected": "Not sent: the connection to the assistant is down.",
    "noReceipt": "Not confirmed: no receipt arrived, so the assistant may not have it.",
    "notStarted": "Not sent: the conversation could not start.",
    "notAccepted": "The host did not confirm the message. Try again. If it keeps failing, the host may be offline or need an update.",
    "undelivered": "Not delivered: the run ended before the assistant read it.",
    "unconfirmed": "Delivery not confirmed: the host could not confirm that it got this answer.",
    "refused": "Not delivered.",
    "backInComposer": "It is back in the message box to send again.",
    "chooseAgain": "Choose your answer again."
  },
  "receiptReason": {
    "invalidMessage": "The message could not be read.",
    "notSubscribed": "This chat is no longer following the run. Reload the page and try again.",
    "senderNotAllowed": "Only the person who started this run can send it messages.",
    "runNotLive": "The run is not running any more.",
    "hostNotConnected": "The host that runs the assistant is not connected.",
    "runnerNotConnected": "The host that runs the assistant is connected, but its runner is not.",
    "messageTooLarge": "The message is too large to send.",
    "channelFull": "The connection to the assistant is busy. Try again in a moment.",
    "inboxFull": "The assistant already has several messages waiting. Send this one after it reads them.",
    "modeDoesNotAccept": "This run does not take messages while it works.",
    "duplicate": "The assistant already has this message.",
    "unknownMessageType": "The server did not recognise the message; it may need an update.",
    "runEndedBeforeDelivery": "The run ended before the assistant read it.",
    "attachmentInvalid": "The attached files could not be verified. Remove and attach them again.",
    "attachmentHostMismatch": "These files were uploaded to another server. Attach them to this run's server.",
    "attachmentHostAmbiguous": "The server that holds these files could not be verified. Attach the files again.",
    "attachmentTooMany": "This message has too many files. Remove some files and try again.",
    "attachmentUnavailable": "The attached files are unavailable. Try again, or remove and attach them again."
  },
  "questionAnswerReason": {
    "answerInProgress": "Another answer to this question is still being checked. Wait a moment and try again.",
    "answerAdmissionUnavailable": "The host could not take the answer in time. Try again.",
    "invalidAnswer": "The answer could not be read. Check it and try again.",
    "attemptConflict": "This answer differs from the earlier send it repeats. Send it again.",
    "questionClosed": "This question is no longer open.",
    "confirmationUnavailable": "The host can no longer confirm whether it got this answer.",
    "senderNotAllowed": "You are not allowed to answer this question.",
    "runNotLive": "The run is not running any more.",
    "attachmentInvalid": "The attached files could not be verified. Remove and attach them again.",
    "attachmentHostMismatch": "These files were uploaded to another server. Attach them to this run's server.",
    "attachmentHostAmbiguous": "The server that holds these files could not be verified. Attach the files again.",
    "attachmentTooMany": "This answer has too many files. Remove some files and try again.",
    "attachmentUnavailable": "The attached files are unavailable. Try again, or remove and attach them again."
  },
  "questionClosed": {
    "cancelled": "This question was withdrawn.",
    "expired": "This question expired.",
    "publicationFailed": "This question could not be shown, so it was closed.",
    "executionEnded": "This question closed when the run ended."
  },
  "composer": {
    "agentWorking": "The assistant is working. You can reply when it asks you a question.",
    "chooseAnOption": "Choose one of the answers above to reply.",
    "questionClosed": "This question is no longer open.",
    "attachUnavailable": "This assistant cannot receive files.",
    "attachFindingHost": "Finding the server that will take your files…",
    "attachGroupOffline": "None of the servers this assistant runs on is online, so it cannot take files now. Try again when one is back.",
    "attachHostNotFound": "The server that would take your files could not be found. Reload the page to try again.",
    "fileNotUploaded": "A file did not upload. Retry it or remove it, then send.",
    "launchFailed": "The conversation could not start.",
    "tooLong": "This message is too long to send. Please shorten it.",
    "pasteTooLong": "That paste would make the message too long to send, so it was not added.",
    "notReadyTool": "This assistant cannot start yet because a tool it uses is not ready. Ask its owner to finish it.",
    "notReadySetup": "This assistant cannot start yet because its setup is not finished. Ask its owner to finish it."
  },
  "launchRefusal": {
    "defaultModelMissing": {
      "admin": "Your organization has no default chat model, so this mission has no agent to run as. Choose one in the admin console under Governance > Resources > Models.",
      "member": "Your organization has no default chat model, so this mission has no agent to run as. Ask an administrator to choose one."
    },
    "openModelSettings": "Open model settings",
    "grantAccessNotReady": {
      "named": "This mission's agent access to {{resources}} is not ready yet, so the run did not start. Try again in a moment. If this keeps happening, contact support@agion.ai.",
      "unnamed": "This mission's agent access is not ready yet, so the run did not start. Try again in a moment. If this keeps happening, contact support@agion.ai."
    },
    "grantAdminDenied": {
      "named": "An administrator has removed this agent's access to {{resources}}, so the run did not start. Ask your administrator, or contact support@agion.ai.",
      "unnamed": "An administrator has removed this agent's access to a resource this mission uses, so the run did not start. Ask your administrator, or contact support@agion.ai."
    },
    "grantTrustTierTooLow": {
      "named": "This agent's trust level does not allow what this mission needs on {{resources}}, so the run did not start. Ask your administrator, or contact support@agion.ai.",
      "unnamed": "This agent's trust level does not allow what this mission needs on a resource this mission uses, so the run did not start. Ask your administrator, or contact support@agion.ai."
    }
  },
  "escalations": {
    "title": "Escalations",
    "fallbackTitle": "Escalation",
    "approve": "Approve",
    "deny": "Deny",
    "reasonPlaceholder": "Reason (optional)",
    "confirmApprove": "Confirm approval",
    "confirmDeny": "Confirm denial",
    "cancel": "Cancel",
    "resolving": "Submitting…",
    "expired": "Expired",
    "expiredNote": "No longer actionable — the step timed out before a decision.",
    "missionLabel": "Mission",
    "actionLabel": "Wants to run",
    "ruleLabel": "Rule",
    "traceToggle": "Policy details",
    "consequence": "Approve runs this step now · Deny blocks it",
    "type": {
      "actionApproval": "Approval required",
      "chatHandoff": "Handoff requested",
      "contentReview": "Content review",
      "guidance": "Guidance requested",
      "complianceReview": "Compliance review",
      "question": "Question"
    },
    "question": {
      "answerPlaceholder": "Your answer",
      "submit": "Send answer",
      "answerLabel": "Answer",
      "answeredByLabel": "Answered by",
      "answeredAtLabel": "Answered at",
      "answerKeptWithRun": "The answer is kept with the run.",
      "unavailable": "This question cannot be shown.",
      "error": {
        "invalid": "The question does not accept this answer.",
        "expired": "The question expired before the answer arrived.",
        "alreadyAnswered": "Someone answered this question first.",
        "forbidden": "You cannot answer this question.",
        "failed": "The answer was not sent. Try again.",
        "ticketMismatch": "The answer did not match your session. Reload the page and try again.",
        "ticketExpired": "The answer took too long to send. Try again.",
        "runNotLive": "The run has ended, so it cannot take the answer.",
        "hostNotConnected": "The host running this mission is not connected. Try again later.",
        "malformed": "The answer could not be read. Try again.",
        "unreachable": "Could not reach the run. Try again.",
        "unconfirmed": "The run has the answer, but it is not recorded yet. Check again shortly."
      },
      "form": {
        "required": "Required",
        "submitNone": "I could not determine any of these",
        "answeredFields": "Fields answered",
        "noneAnswered": "No field could be determined.",
        "error": {
          "number": "Enter a number.",
          "date": "Enter a complete date."
        }
      }
    },
    "evidence": {
      "open": "Open evidence",
      "hide": "Hide evidence",
      "opening": "Opening…",
      "label": "Evidence",
      "task": "Task",
      "context": "Context",
      "constraints": "Constraints",
      "error": {
        "unavailable": "The evidence cannot be opened.",
        "tooLarge": "The evidence is too large to open here.",
        "failed": "The evidence did not open. Try again."
      }
    },
    "questionCard": {
      "waiting": "A question is waiting for someone who can decide it.",
      "answered": "Answered",
      "askedBy": "Asked by",
      "evidenceTitle": "What the specialist saw",
      "evidenceUnavailable": "The evidence cannot be shown here.",
      "evidenceEmpty": "The specialist was given no details."
    },
    "header": {
      "questionWaiting": "A question is waiting",
      "unknownMission": "A mission",
      "answerInEscalations": "Answer in Escalations"
    },
    "reviewReason": {
      "decisionCouldNotChoose": "The decision model couldn't choose.",
      "decisionUnavailable": "The decision model wasn't available.",
      "agentUnsure": "The specialist's model wasn't sure.",
      "agentUnavailable": "The specialist's model wasn't available.",
      "agentModelSkipped": "The mission asks a person directly when the decision model can't choose."
    }
  },
  "operatorTakeover": {
    "personMarker": "Person",
    "takeOver": "Take over",
    "takingOver": "Taking over…",
    "heldByYou": "You are holding this conversation.",
    "openConversation": "Open conversation",
    "banner": "You are replying as yourself to the customer",
    "holdUntil": "You hold this conversation until {{time}}.",
    "ended": "You no longer hold this conversation.",
    "notHeld": "This conversation is not held by you.",
    "earlierRunsIncomplete": "Part of the earlier conversation could not be loaded.",
    "placeholder": "Write to the customer",
    "send": "Send",
    "handBack": "Hand back",
    "handingBack": "Handing back…",
    "handBackFailed": "The conversation was not handed back. Try again.",
    "reply": {
      "sending": "Sending…",
      "accepted": "Delivered to the customer",
      "notSent": "Not sent: the connection is down.",
      "refused": "Refused"
    },
    "refusal": {
      "expired": "The request expired before you took it over.",
      "self": "You started this conversation, so someone else has to take it over.",
      "notPending": "Someone else took this conversation over, or it ended.",
      "forbidden": "You cannot take over this conversation.",
      "failed": "The conversation was not taken over. Try again."
    },
    "replyRefusal": {
      "malformed": "The reply could not be read. Check the text and send it again.",
      "senderNotAllowed": "Sign in again to reply.",
      "notSubscribed": "This conversation is not open here. Reload it and reply again.",
      "disabled": "Taking over conversations is switched off.",
      "noHold": "You no longer hold this conversation.",
      "notOperator": "Another person holds this conversation.",
      "unavailable": "The conversation could not be reached. Try again.",
      "other": "The reply was refused."
    }
  },
  "notifications": {
    "hitlTitle": "Mission needs your response",
    "governanceTitle": "Governance alert",
    "escalationTitle": "Escalation awaiting decision"
  },
  "delegation": {
    "blocked": {
      "label": "Blocked by setup",
      "message": "{{agent}} could not finish: {{reason}}.",
      "targetNotBound": "the system is not connected to this mission",
      "targetNotAuthorized": "this mission is not authorized to use the system",
      "operationOutsideScope": "the operation is not allowed in this mission",
      "credentialUnavailable": "the connection has no usable credentials",
      "other": "the mission setup does not allow this request",
      "hint": "The mission author or an administrator can change this."
    }
  },
  "launchInputs": {
    "title": "Start values",
    "hint": "The run starts with these values.",
    "enterValue": "Enter a value to start the run.",
    "invalidJson": "Enter valid JSON, for example {\"key\": \"value\"} or [1, 2].",
    "invalidNumber": "Enter a number.",
    "invalidInteger": "Enter a whole number.",
    "invalidBoolean": "Enter true or false.",
    "selectFile": "Select an uploaded file",
    "uploadFile": "Upload a file",
    "uploadingFile": "Uploading file…",
    "uploadFailed": "File upload failed.",
    "retryUpload": "Retry upload",
    "removeFile": "Remove file",
    "completeFile": "Select a file whose upload has completed.",
    "nextMessageStartsRun": "Your next message starts a new run.",
    "changeValues": "Change start values",
    "hideValues": "Hide start values",
    "startValuePlaceholder": "Type a value and press Enter to start a new run."
  },
  "nextSections": {
    "attention": {
      "title": "Needs Your Response",
      "awaitingInput": "Waiting for your input",
      "policyDecision": "Policy decision",
      "escalate": "Escalate"
    },
    "recent": {
      "loadError": "Recent conversations could not be loaded",
      "nameNotLoaded": "Mission name not loaded",
      "outcome": {
        "running": "Running",
        "completed": "Completed",
        "failed": "Failed",
        "cancelled": "Stopped"
      }
    }
  },
  "nextConversation": {
    "agent": "Agent",
    "copy": "Copy",
    "helpful": "Helpful",
    "notHelpful": "Not helpful",
    "attach": "Attach files",
    "voice": "Voice input",
    "send": "Send message",
    "hint": "Enter to send · Shift+Enter for new line",
    "working": "The mission is working",
    "governance": {
      "deny": "Denied",
      "obfuscate": "Masked",
      "escalate": "Escalated",
      "audit": "Logged"
    },
    "historyLoadError": "This conversation could not be loaded from the Edge host",
    "question": {
      "closed": "This question is no longer open.",
      "submit": "Send answer",
      "atLeast_one": "Pick at least {{count}} option.",
      "atLeast_other": "Pick at least {{count}} options.",
      "otherLabel": "Other",
      "otherPlaceholder": "Write your answer"
    },
    "escalation": {
      "approve": "Approve",
      "deny": "Deny",
      "approveConsequence": "When you approve, {{agent}} continues its run and carries out the action it asked for.",
      "denyConsequence": "When you deny, {{agent}} does not carry out the action, and the step of the run that asked fails.",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Reason...",
      "reasonRequired": "A reason is required.",
      "confirmApprove": "Confirm approve",
      "confirmDeny": "Confirm deny",
      "cancel": "Cancel",
      "backToRequest": "Back"
    }
  },
  "nextActivity": {
    "turn": "Turn",
    "thinking": "Thinking",
    "started": "Started",
    "completed": "Completed",
    "failed": "Failed",
    "succeeded": "Succeeded",
    "waiting": "waiting...",
    "humanInput": "Human Input",
    "humanResponse": "Human Response",
    "orchestrator": "Orchestrator",
    "delegatedTo": "Delegated to",
    "error": "Error",
    "terminalFailure": "Terminal failure",
    "thinkingRedactedBody": "The model's internal reasoning has been hidden.",
    "model": "Model",
    "tokens": "Tokens",
    "duration": "Duration",
    "depth": "Depth",
    "in": "in",
    "out": "out",
    "filterAll": "All",
    "filterTurns": "Turns",
    "filterTools": "Tools",
    "filterHitl": "HITL",
    "expand": "Show more",
    "collapse": "Show less",
    "statusRunning": "Executing mission",
    "statusComplete": "Run complete",
    "statusPaused": "Paused",
    "statusFailed": "Run failed",
    "steps": "Steps",
    "costLive": "Cost so far",
    "costEstimate": "Est. cost",
    "costUnknown": "Unknown",
    "usageNotReported_one": "{{count}} call, usage not reported",
    "usageNotReported_other": "{{count}} calls, usage not reported",
    "costExcludesUnreported_one": "Excludes {{count}} call without reported usage",
    "costExcludesUnreported_other": "Excludes {{count}} calls without reported usage",
    "checkingModelUse": "Checking model use…",
    "tokenSpend": "Token spend",
    "awaitingFirstCall": "Awaiting first model call",
    "executionLog": "Execution log",
    "jumpToLatest": "Jump to latest",
    "showBreakdown": "Show per-model breakdown",
    "hideBreakdown": "Hide per-model breakdown",
    "unnamedStep": "Unnamed step",
    "runEnding": {
      "tool_result_too_large": "A tool returned too much data",
      "host_disconnected": "The host lost its connection",
      "idle_timeout": "The run stopped responding",
      "context_window_exhausted": "The conversation grew too long for the model",
      "llm_deadline": "The model did not answer in time",
      "mission_budget_exceeded": "The run used up its budget",
      "provider_unavailable": "The model provider was busy or down",
      "provider_quota_exhausted": "The model provider's quota is used up",
      "model_tool_format_rejected": "The model could not use the mission's tools",
      "repeated_gate_rejection": "The run kept failing the same completion check",
      "criteria_not_met": "The answer did not meet all success criteria",
      "no_successful_resource_evidence": "No data came from the connected systems",
      "timeout": "A call took too long",
      "permission_denied": "Access was refused",
      "not_found": "Something was not found",
      "rate_limited": "Too many requests",
      "network_error": "A system could not be reached",
      "service_unavailable": "A system was unavailable",
      "validation_error": "A request was rejected as invalid",
      "token_limit": "The model's length limit was reached",
      "internal_error": "An unexpected error",
      "schema_error": "An answer had an unexpected shape",
      "model_output_unfit": "The model kept giving answers that could not be shown",
      "transport_error": "The run's messages could not be passed along",
      "tool_blocked": "Agion blocked the call"
    },
    "statusStarting": "Starting",
    "statusDone": "Done",
    "waitingForAnswer": "Waiting for your answer",
    "noModelUse": "No model use recorded for this run",
    "questionStep": "Question",
    "messageToYou": "Message to you",
    "answerStep": "Answer",
    "agentStep": "Agent",
    "runStep": "Run",
    "stepId": "Step id",
    "filterQuestions": "Questions"
  },
  "header": {
    "search": "Search messages",
    "closeSearch": "Close search",
    "metaStarted": "Started {{time}}",
    "metaTrust": "{{tier}} trust",
    "metaRuns": "{{count}} runs",
    "allRuns": "All runs",
    "moreActions": "More actions"
  },
  "nextRunStep": {
    "running": "Running",
    "waiting": "Not running",
    "completed": "Completed",
    "warning": "Completed with a warning",
    "failed": "Failed",
    "moreTools_one": "+{{count}} more",
    "moreTools_other": "+{{count}} more",
    "unnamedStep": "Unnamed step"
  },
  "runEnd": {
    "endedWithCause": "The run ended: {{cause}}.",
    "missing": "Missing: {{items}}.",
    "failed": "The run failed.",
    "cause": {
      "agent": "the agent could not finish the work",
      "person": "it was waiting for a person",
      "environment": "a connected system or service did not work as needed",
      "platform": "the platform had a problem",
      "missionDesign": "the mission's settings or limits stopped it",
      "unknown": "the reason was not recorded",
      "noAnswer": "no one answered in time"
    },
    "next": {
      "agent": "Make the task clearer, then run it again.",
      "person": "Run the mission again when someone can answer.",
      "environment": "Check the connected system or service, then run the mission again.",
      "missionDesign": "Check the mission's settings and limits, then run it again.",
      "platform": "Run the mission again. If it happens again, contact your administrator.",
      "unknown": "Run the mission again. If it happens again, contact your administrator.",
      "noAnswer": "Run the mission again when someone can answer."
    },
    "missingItem": {
      "criteria": "all success criteria met",
      "resourceData": "data from the connected systems",
      "personAnswer": "an answer from a person",
      "stepOutputs": "every step's outputs",
      "time": "time to finish",
      "room": "room for the model to read everything"
    },
    "cutNote": {
      "title": "Some values in this run were shortened to fit its limits.",
      "kind": {
        "delegationHandoff": "Results handed from one agent to another were shortened or left out.",
        "taskPromptValue": "Some earlier results were shortened to fit the model.",
        "contextShortened": "Earlier messages in the conversation were shortened to fit the model.",
        "runStateText": "Results of earlier goals and collected answers were shortened.",
        "verdictEvidence": "The evidence quoted in the answer check was shortened.",
        "hydratedRows": "A step received only the first rows of a large table.",
        "schemaTables": "Some tables or datasets of a connected system were left out of what the model was shown.",
        "runLimitBounded": "A limit set in the mission was above its maximum, so the run used the maximum."
      },
      "storage": "Turning on workspace storage on the host keeps the values whole."
    },
    "code": {
      "CONTEXT_LIMIT": {
        "title": "The text sent to the model was too long, even after shortening",
        "next": "Shorten the input or split the task into smaller parts, then run it again."
      },
      "RUN_TIME_LIMIT": {
        "title": "The time limit was reached",
        "next": "An organisation administrator can raise the run time limit in Settings, within the range Agion allows, or narrow the task so it finishes sooner."
      },
      "SOURCE_READ_INCOMPLETE": {
        "title": "A connected system stopped sending data before the read finished",
        "next": "Check the connected system, then run the mission again."
      },
      "PROVIDER_QUOTA_EXHAUSTED": {
        "next": "An organisation administrator can raise the quota with the model provider or choose another model."
      }
    },
    "codeLabel": "Code: {{code}}",
    "reason": {
      "hostStoreFull": {
        "title": "The host's store for results was full with the data of runs still in progress",
        "next": "An organisation owner or administrator can check the size limit for stored results on the host's page, then run the mission again."
      }
    }
  }
}
